import { queryOptions } from "@tanstack/react-query";
import type { VersionAnnouncement } from "@nexus/contracts";
import { authFetch } from "@/lib/api-client";

async function getVersionAnnouncement(): Promise<VersionAnnouncement | null> {
  const { data } = await authFetch<VersionAnnouncement | null>(
    "/version/announcement",
  );
  return data;
}

export const versionKeys = {
  announcement: (announcementId: string) =>
    ["version", "announcement", announcementId] as const,
} as const;

/**
 * Release notes for one announcement id. Keyed by id and never stale, so the
 * heartbeat can keep reporting the same id without refetching. Fetched only
 * once the client sees an id it has not acknowledged.
 */
export function versionAnnouncementQueryOptions(
  announcementId: string | undefined,
) {
  return queryOptions({
    queryKey: versionKeys.announcement(announcementId ?? "none"),
    queryFn: getVersionAnnouncement,
    enabled: Boolean(announcementId),
    staleTime: Infinity,
    meta: { skipGlobalError: true },
  });
}
